import { render, staticRenderFns } from "./redpipe.vue?vue&type=template&id=dd65eec2&scoped=true"
import script from "./redpipe.vue?vue&type=script&lang=js"
export * from "./redpipe.vue?vue&type=script&lang=js"
import style0 from "./redpipe.vue?vue&type=style&index=0&id=dd65eec2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd65eec2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/redpipe.vue
// module id = H+14
// module chunks = 0